var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarLoadingXxl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M22.52 23.958a7.127 7.127 0 0 1-3.621-.954 6.992 6.992 0 0 1-2.611-2.611 7.127 7.127 0 0 1-.955-3.622c0-1.31.319-2.518.955-3.622a6.992 6.992 0 0 1 2.611-2.611 7.127 7.127 0 0 1 3.622-.955c1.31 0 2.517.319 3.622.955a6.992 6.992 0 0 1 2.61 2.611 7.127 7.127 0 0 1 .955 3.622c0 1.31-.318 2.517-.954 3.622a6.992 6.992 0 0 1-2.611 2.61 7.127 7.127 0 0 1-3.622.955zm5.486.959c1.334 0 2.577.333 3.726 1a7.391 7.391 0 0 1 2.725 2.726 7.295 7.295 0 0 1 1.001 3.726v2.336c0 .742-.26 1.372-.778 1.891-.52.52-1.15.779-1.891.779H13.21c-.741 0-1.372-.26-1.89-.779a2.575 2.575 0 0 1-.78-1.89v-2.337c0-1.334.334-2.577 1.002-3.726a7.391 7.391 0 0 1 2.725-2.725 7.295 7.295 0 0 1 3.726-1.001h.946a9.658 9.658 0 0 0 4.06.89 9.658 9.658 0 0 0 4.06-.89h.946z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarLoadingXxl);
export default __webpack_public_path__ + "static/media/avatar-loading-xxl.7ac79c6f5e3b971f8a08bc36df8c6399.svg";
export { ForwardRef as ReactComponent };